import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center vh-100 text-center"
      style={{
        backgroundColor: "#f8f9fa",
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: "6rem", fontWeight: "bold" }}>404</h1>
      <h3>Oops! Page Not Found</h3>
      <p className="text-muted mb-4">
        The page you’re looking for doesn’t exist or has been moved.
      </p>
      <Link
        to="/"
        className="btn btn-primary px-4 py-2 rounded-pill"
        style={{ fontWeight: "600" }}
      >
        Go Back Home
      </Link>
    </div>
  );
}
